export default __webpack_public_path__ + "static/media/BotDefaultAvatar.0f506785.svg";